import { ProductDisabledType } from '@/features/YTLive/LiveProducts/getProductDisabledType';

const ytLive = {
  'Learn more': '了解更多',
  'Field youtubeId': 'YouTube 频道 ID',
  'Field youtubeUrl': 'YouTube 频道 URL',
  'Field brandHomeUrl': '商店 URL',
  'Field date': '预计直播时间',
  'Field date - description':
    '请注意！在您按下前往开播按钮时，您的商品才会实际展示于Google Merchant Center / YouTube 后台，以上两大步骤设定完成后，建议您于正式直播的三天前，在预计直播的YouTube 频道先择期试播一次，以确保顺利开播。\n*提醒您，因 YouTube / Google Merchant Center 平台上传商品限制，仅能选择当下 24 小时后的时间作为您的预计直播时间。',
  'Live Products': '直播商品',
  'Live Products - counter': '({{count}}/{{max}})',
  'Live Products - description':
    '请提供您预计直播的时间。选择好后，隐藏商品将会随着您选择到的预计直播时间露出于商店前台及 YouTube 前后台。另外提醒您：因 Google Merchant Center 及 YouTube 平台限制，在您选择到「预计直播时间」后，我们在您直播前 24 小时将不再开放编辑时间。',
  'Live Products - min error': '直播商品是必填项目，请选择直播商品',
  'Live Products - max error':
    '一个直播间仅限添加 {{count}} 个商品，请减少直播商品数量',
  'Live Products - nav content': '选择或建立直播的商品',
  'Add Products': '选择直播商品',
  'Live Products columns - Product': '商品',
  'Live Products columns - Price': '价格',
  'Live Products columns - Inventory': '可售数量',
  'Live Products columns - Status': '状态',
  'Live Products status - reminder on': '缺货提醒：开启',
  'Live Products status - reminder off': '缺货提醒：关闭',
  'Live Products status - hidden': '隐藏商品',
  'Live Products status - schedulePublishAt': '于 {{date}} 上架',
  'Live Products status - availableStartTime start': '开始销售：{{date}}',
  'Live Products status - availableStartTime period': '销售时间：{{date}}',
  'Live Products status - availableStartTime end': '销售结束：{{date}}',
  [`Live Prdoucts disabled_${ProductDisabledType.unpublished}`]: '已下架',
  [`Live Prdoucts disabled_${ProductDisabledType.emptyPrice}`]:
    '无法添加无价格商品',
  [`Live Prdoucts disabled_${ProductDisabledType.hiddenPrice}`]:
    '无法添加隐藏价格商品',
  'LiveProductsPicker - SearchBar placeholder': '搜寻商品名称或 SPU',
  'LiveProductsPicker - No result': '找不到商品',
  'LiveProductsPicker - No result description':
    '请尝试更改关键字或筛选套用词/编号',
  'LiveProductsPicker - View selected products':
    '检视已选商品 ({{count}}/{{max}})',
  'LiveProductsPicker - View all products': '检视全部商品',
  'Youtube Admin Preparation': 'YouTube 后台准备',
  'Youtube Admin Preparation - description':
    '由于 YouTube 平台限制，暂不支援于 SHOPLINE 后台直接开播，更多直播功能敬请期待。如需终止直播请至 YouTube 后台操作。开始直播售卖商品前，请参考以下步骤：',
  'Youtube Admin Preparation - nav content': '需要在平台设定做好准备',
  'Youtube Admin Preparation StepOne': '于 YouTube 工作室设定频道展示商品',
  'Youtube Admin Preparation StepOne - description':
    '当您设定好 Google Merchant Center Content API 后，商品将自动上传至您的 Google Merchant Center 及 YouTube Live Shopping 后台，您可以至 YouTube 后台管理设定中心将想要在直播当下展示的商品勾选起来。',
  'Youtube Admin Preparation StepTwo': '标记直播中要展示的商品',
  'Youtube Admin Preparation StepTwo - description':
    '并可于直播当下标记钉选商品至频道中，让您的买家能够边看边买',
  'Youtube Admin Preparation StepThree': '在预定时间开播并置顶商品',
  'Youtube Admin Preparation StepThree - description':
    '直播期间，可搭配置顶功能让介绍的商品更显眼。',
  'Finish Setting': '完成',
  'Finish Setting - description': '完成以上设定步骤之后，就可以马上开播了！',
  'Start Streaming': '前往 YouTube 开播',
  'exceeded the LIVE Broadcast time':
    '此直播间已失效（超过直播时间），本次编辑时间将不储存；欲进行开播请新增一新的直播间',
  'Youtube Tnc':
    '于设定本功能时您已充分知悉相关规定，请参阅 <YoutubePrivacyLink></YoutubePrivacyLink>及以下相关规定。',
  'Youtube Privacy': 'YouTube 隐私权政策',
  'Youtube Tnc Detail':
    '请注意，当您串接 YouTube Shopping 时，代表您同意将网路商店中来自 YouTube 的订单数据传输给 YouTube。',
  'Setup Guide YouTube Shopping Setup': 'YouTube Shopping 直播间设定',
  'Field Channel': '频道',
  'Setup Guide Choose Channel Title': '选择 YouTube 频道',
  'Setup Guide Choose Channel Description':
    '注意：商店包含隐藏商品，在所有串接的 YouTube 频道后台将显示这些商品。',
  'Setup Guide Choose Channel Dropdown Placeholder': '请选择',
  'Setup Guide No Available Channels': '商店没有已串接的 YouTube 频道',
  'Setup Now': '前往启用',
  'Schedule Live Stream Title': '预计直播时间',
  'Schedule Live Stream Description':
    '请选择您预计直播的时间，隐藏商品将在预计直播时间显示于商店前台及 YouTube 前后台。 *提醒您，因 Google Merchant Center 及 YouTube 平台上传商品限制，仅能选择当下 24 小时后的时间作为您的预计直播时间，且在直播前 24 小时不支援编辑时间。',
  'Live Stream Products Title': '直播商品',
  'Live Stream Products Description':
    '请选择直播商品，在您按下储存按钮时，您的商品才会实际显示于 Google Merchant Center / YouTube 后台。',
  'YouTube Preparation Title': 'YouTube 后台准备',
  'YouTube Preparation Description':
    '由于 YouTube 平台限制，暂不支援于 SHOPLINE 后台直接开播，终止直播也请至 YouTube 后台操作，更多直播功能敬请期待。 开始直播贩售商品前，请参考以下步骤：',
  'Account Linking YouTube Preparation StepOne':
    '1. 于 YouTube 工作室设定频道展示商品',
  'Account Linking YouTube Preparation StepOne - description':
    '当您已完成 Google Merchant Center Content API 设定，商品将自动上传至您的 Google Merchant Center 及 YouTube 后台，您可以至 YouTube 后台选取要在频道展示的商品。',
  'Account Linking YouTube Preparation StepTwo': '2. 标记直播中要展示的商品',
  'Account Linking YouTube Preparation StepTwo - description':
    '您可以标记商品，使其展示在直播中，让观众能够边看边买。',
  'Account Linking YouTube Preparation StepThree':
    '3. 在预定时间开播并置顶商品',
  'Account Linking YouTube Preparation StepThree - description':
    '直播期间，可搭配置顶功能让介绍的商品更显眼。',
  'Finish YouTube Setting': '完成',
};

export default ytLive;
